module.exports = __webpack_public_path__ + "img/RBY-alt.24487358.svg";